import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { find, intersection } from 'lodash';
import { PpbToasterService } from 'projects/ppb-shared-library/src/lib/pseic-toaster/ppb-toaster.service';
import { UserElementalRole } from '../../../ppb/shared/models/user-elemental-role';
import { UserService } from '../../../ppb/shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class HasUserElementalRoleGuard  {
  private readonly fistPossiblePathLookup: { path: string, roles: UserElementalRole[] }[] = [
    { path: '/dashboard', roles: [UserElementalRole.GEN_DASHBOARD] },
    { path: '/account/data', roles: [UserElementalRole.ACC_PREVIEW] },
  ];

  constructor(
    private userService: UserService,
    private router: Router,
    private toaster: PpbToasterService,
  ) {
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.canActivate(route);
  }

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const role: UserElementalRole = route.data['requiredElementalRole'];
    return role === undefined || this.userService.hasRole(role) || this.lookupFirstPossiblePath();
  }

  private lookupFirstPossiblePath(): UrlTree | boolean {
    const redirectTo = find(
      this.fistPossiblePathLookup,
      (rolesConfig) => intersection(rolesConfig.roles, this.userService.userRoles).length > 0
    );

    const text = $localize`:@@shared.no_app_access:Nie posiadasz dostępu do tej części aplikacji`;


    this.toaster.open(text, 'warning');

    return redirectTo ? this.router.parseUrl('/' + redirectTo.path) : false;
  }

}
